/** @flow */

import type { SalesPromotionParameters } from 'common/modules/sales/domain/SalesPromotionParameters';
import type { Dispatch, GetState } from '../../../types/Store';
import { getToken, getStation } from '../../authentication/session/selectors/sessionSelectors';
import PromotionsAPI from '../services/PromotionsAPI';

export const CREATE_NEW_PROMOTION = 'PromotionActions/CREATE_NEW_PROMOTION';
export const CREATE_NEW_PROMOTION_SUCCESS = 'PromotionActions/CREATE_NEW_PROMOTION_SUCCESS';
export const CREATE_NEW_PROMOTION_ERROR = 'PromotionActions/CREATE_NEW_PROMOTION_ERROR';

export const FETCH_PROMOTIONS = 'promotionActions/FETCH_PROMOTIONS';
export const FETCH_PROMOTIONS_SUCCESS = 'promotionActions/FETCH_PROMOTIONS_SUCCESS';
export const FETCH_PROMOTIONS_FAILED = 'promotionActions/FETCH_PROMOTIONS_FAILED';


export const createNewPromotion = (promotion: SalesPromotionParameters) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: CREATE_NEW_PROMOTION });

    try {
      const callSign = getStation(getState());
      const token = getToken(getState());

      const returned = await PromotionsAPI.createNewPromotion(callSign, token, promotion);

      dispatch({ type: CREATE_NEW_PROMOTION_SUCCESS, promotion: returned });
    } catch (error) {
      dispatch({ type: CREATE_NEW_PROMOTION_ERROR, error });
    }
  };
};

export const fetchPromotions = () => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: FETCH_PROMOTIONS });

    try {
      const callSign = getStation(getState());
      const token = getToken(getState());

      const promotions = await PromotionsAPI.fetchPromotions(callSign, token);

      dispatch({ type: FETCH_PROMOTIONS_SUCCESS, promotions });
    } catch (error) {
      dispatch({ type: FETCH_PROMOTIONS_FAILED, error });
    }
  };
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/promotions/actions/promotionActions.js